// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ここから追加
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';

// headタグ分岐用
import { HelmetProvider } from '@dr.pogodin/react-helmet';
window.dataLayer = window.dataLayer || [];

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // キャッシュ保持時間
      refetchOnWindowFocus: false, // フォーカス時の自動再フェッチを無効化
      retry: 1, // エラー時のリトライ回数
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      {/* React Query を App ごとラップ */}
      <QueryClientProvider client={queryClient}>
        {/* 既存の ThemeProvider はそのまま中に */}
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
